import React from "react";
import Head from "next/head";

import NewsroomMain from "@/components/media/newsroom-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { announcementsData } from "@/components/media/announcement-data";
import { AnnouncementType } from "@/@types/Annoucement";

type Props = {
  announcementItems: AnnouncementType[];
};

const Newsroom = ({ announcementItems }: Props) => {
  return (
    <>
      <Head>
        <title>{seoData.NEWSROOM.title}</title>
        <SeoMetaData data={seoData.NEWSROOM} />
      </Head>

      <NewsroomMain announcements={announcementItems} />
    </>
  );
};

export async function getStaticProps() {
  // Convert JSX tags to string representation
  const serializedData = JSON.stringify(announcementsData);

  // Pass the serialized data as props
  return {
    props: {
      announcementItems: await JSON.parse(serializedData),
    },
  };
}

export default Newsroom;
